<div class="retention-workflows-filters">
  <!-- Status Filter Section -->
  <div class="filter-section">
    <div class="section-header">
      <h3 class="filter-section-title">Status</h3>
    </div>
    <div class="filter-control">
      <p-multiSelect
        [options]="statusOptions"
        [formControl]="filterForm.controls.status"
        optionLabel="label"
        optionValue="value"
        placeholder="All statuses"
        [disabled]="loading"
        display="chip"
        appendTo="body"
        [autoZIndex]="true"
        [baseZIndex]="9999"
        class="w-full"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} selected"
        styleClass="clean-multiselect"
      />
    </div>
  </div>

  <!-- Triggered By Filter Section -->
  <div class="filter-section">
    <div class="section-header">
      <h3 class="filter-section-title">Triggered By</h3>
    </div>
    <div class="filter-control">
      <p-multiSelect
        [options]="triggeredByOptions"
        [formControl]="filterForm.controls.actionTrigger"
        optionLabel="label"
        optionValue="value"
        placeholder="All triggers"
        [disabled]="loading"
        display="chip"
        appendTo="body"
        [autoZIndex]="true"
        [baseZIndex]="9999"
        class="w-full"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} selected"
        styleClass="clean-multiselect"
      />
    </div>
  </div>
</div>
